import { render, staticRenderFns } from "./KegCreateBatchModal.vue?vue&type=template&id=013a3963&scoped=true"
import script from "./KegCreateBatchModal.vue?vue&type=script&lang=js"
export * from "./KegCreateBatchModal.vue?vue&type=script&lang=js"
import style0 from "./KegCreateBatchModal.vue?vue&type=style&index=0&id=013a3963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a3963",
  null
  
)

export default component.exports